import { Link } from 'react-router-dom';
import Footer from '../CommonComponents/Footer';

const Login = () => {
  return (
    <div className="min-h-screen w-full flex font-lato">
      {/* Left Section - Branding (30%) */}
      <div className="w-[70%] bg-gradient-to-b from-[#AD0C62] to-[#621C43] text-white flex flex-col justify-between">
        <div className="flex font-lato font-bold  justify-between border-b border-[#A40E5F] p-6">
          <h1 className="text-6xl font-bold">
            MillionMakers™ <br /> Admin Portal
          </h1>
          <img src="/images/logo.png" className="h-34" alt="logo" />
        </div>
        <div className="p-6">
          <p className="text-[50px] font-lato font-regular leading-tight w-[80%] ">
            Create, manage and analyse <br />
            surveys and activities to collect
          </p>
          <h2 className="text-5xl leading-tight ">Direct Worker Voice </h2>
        </div>
      </div>

      {/* Right Section - Login (70%) */}
      <div className="w-[40%] bg-[#c698b040] text-[#A40E5F] flex flex-col justify-between">
        <div className=" flex flex-col justify-between">
          {/* Title */}
          <div className=" border-b border-[#A40E5F] w-[100%] ">
            <h2 className="pl-10 text-[50px] font-lato font-regular w-[100%] mt-[50px] pb-6 ">
              Log in to <br /> Continue
            </h2>
          </div>
          {/* Buttons */}
          <div className="absolute bottom-6 right-2 flex p-10 mt-10 gap-4 w-[35%] ">
            <Link
              to="/login/otp"
              className="flex-1 py-3 rounded bg-[#EA600E] text-white text-center hover:bg-orange-500 transition"
            >
              Login
            </Link>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Login;
